import { evaluate } from './evaluate/index';
import { fastClone } from './fast-clone';
import { set } from './set';
import { transformBlock } from './transform-block';
const evaluateBindings = ({ block, context, localState, rootState, rootSetState }) => {
    if (!block.bindings) {
        return block;
    }
    const copy = fastClone(block);
    const copied = {
        ...copy,
        properties: {
            ...copy.properties
        },
        actions: {
            ...copy.actions
        }
    };
    for (const binding in block.bindings) {
        const expression = block.bindings[binding];
        const value = evaluate({
            code: expression,
            localState,
            rootState,
            rootSetState,
            context,
            enableCache: true
        });
        set(copied, binding, value);
    }
    return copied;
};
export function getProcessedBlock({ block, context, shouldEvaluateBindings, localState, rootState, rootSetState }) {
    const transformedBlock = transformBlock(block);
    if (shouldEvaluateBindings) {
        return evaluateBindings({
            block: transformedBlock,
            localState,
            rootState,
            rootSetState,
            context
        });
    }
    else {
        return transformedBlock;
    }
}
